<template>
    <div>
        <div :class="['sliding-menu', { 'open': isOpen }]">
            <ul>
                <template v-for="app in (user.employer_data.quickLaunchApps || [])">
                    <li v-if="app.platform === 'web'">
                        <a :href="app.platform_resource" target="_blank">
                            <div class="sliding-menu__item">
                                <img :src="app.icon_url" alt="">
                                <div class="sliding-menu__app-text-block">
                                    <p class="title">{{ app.app_name }}</p>
                                    <p class="description">{{ app.short_description }}</p>
                                </div>
                            </div>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
        <button @click="toggleMenu" :class="['sliding-menu-button', { 'open': isOpen }]">
            <img src="/images/app/my-apps.svg" alt="Icon" id="my-apps-icon"/>
            My Apps <i :class="{'fa fa-chevron-down': isOpen, 'fa fa-chevron-up': !isOpen}"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SlidingMenuComponent',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        }
    }
};
</script>

<style lang="scss" scoped>
.sliding-menu {
    position: fixed;
    top: 0;
    right: -288px;
    width: 288px;
    height: 100%;
    transition: right 0.3s ease;
    z-index: 1000;
    padding: 40px 15px 0;
    background: #FFFFFF 0 0 no-repeat padding-box;
    border-left: 1px solid #206FB1;
    opacity: 1;
    box-shadow: 0 -3px 16px #00000019;
    overflow-y: auto;

    ul {
        list-style-type: none;
        height: calc(100vh - 70px);
        overflow-y: auto;
        padding: 0;
    }
    li {
        padding: 0 15px 0 0;
    }
    a {
        text-decoration: none;
    }
    .sliding-menu__item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
        color: #000;
        overflow: hidden;
        padding-bottom: 2px
    }
    img {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        border-radius: 15px;
        margin-right: 15px;
        object-fit: cover;
    }

    .sliding-menu__app-text-block {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 52px;
        overflow: hidden;

        p {
            margin: 0;
            line-height: 1.2;
            max-width: 100%;
            overflow: hidden;
        }

        .title {
            margin-bottom: 2px;
            font: normal normal bold 14px/20px Nunito;
            letter-spacing: 0;
            color: #000000DE;
            opacity: 1;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        .description {
            font: normal normal normal 14px/16px Nunito;
            letter-spacing: 0.09px;
            color: #000000;
            opacity: 1;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}

.sliding-menu.open {
    right: 0;
}

.sliding-menu-button.open {
    right: 288px;
}

.sliding-menu-button {
    position: fixed;
    top: 43px;
    padding: 18px 13px;
    cursor: pointer;
    z-index: 1001;
    transition: right 0.3s ease;
    background: #BFD1E2 0 0 no-repeat padding-box;
    box-shadow: 0 -3px 20px #00000029;
    border: 1px solid #206FB1;
    border-radius: 4px 4px 0 0;
    opacity: 1;
    color: #0b5a9c;
    font: normal normal bold 16px/16px Open Sans;
    letter-spacing: 0.21px;
    height: 58px;
    right: 0;
    width: 153px;
    transform: rotate(-90deg);
    transform-origin: bottom right;

    .fa-chevron-down,
    .fa-chevron-up {
        margin-left: 10px;
    }

    #my-apps-icon {
        height: 14px;
        margin-bottom: 2px;
        margin-right: 8px;
        width: 14px;
    }

    .sliding-menu, .sliding-menu-button {
        transition: right 0.3s ease;
    }
}
</style>
